import { Injectable, Inject, EventEmitter } from '@angular/core';
import { HttpService, AuthenticationService } from 'ew-common-lib';
import { Observable, of, throwError,BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class EwMaIntegrationService {
  [x: string]: any;
  /**
   * @description
   * API token for authentication.
   */
  private token: string;

  /**
   * @description
   * Event id to use in the library
   */
  public event_id: string;
  public integration: any;
  public environment: any;



  /**
   * @description
   * Inject services to use in this component.
   * @param env environment file for API base URLs.
   * @param httpService http service to call APIs.
   * @param authenticationService To get auth token.
   */
  constructor(
    @Inject('env') private env,
    private httpService: HttpService,
    private authenticationService: AuthenticationService
  ) {
    this.environment = env;
    this.token = this.authenticationService.getUserAccessToken();
  }
    /**
   * @description
   * Generates full url for API request.
   * @param url Resource name
   */
     getUrl(url: string) {
      return this.environment.apiBaseUrl + url;
    }

  getIntegtaionList(model) {
    const url = this.getUrl("v1/integrations/"+model.webinar_id+"/all-integrations");
    delete model.webinar_id;
    return  this.httpService
      .get(this.token,url,model)
      .pipe(catchError(this.handleError<any>('getAllIntegrations')));;

}
getIntegtaionAllData(model) {
    const url = this.getUrl("v1/integrations/"+model.webinar_id+"/fetch-integration-all-data");
    delete model.webinar_id;
    return  this.httpService
      .get(this.token,url,model)
      .pipe(catchError(this.handleError<any>('getAllIntegrations')));;

}

    /**
   * @description
   * SAve integration details to db
   * @param model Data to attach with API.
   */
     saveIntegration(model: any) {    
      let url = this.getUrl('v1/integrations/'+model.webinar_id+'/add-integration');  
      delete model.webinar_id;
      return this.httpService
        .post(this.token, url, model)
       .pipe(catchError(this.handleError<any>('Add Integration')));
    }
/*
   * @description
   * Remove selected tag/list from db
   * @param model Data to attach with API.
   */
     removeSelectedTag(model: any) {    
      let url = this.getUrl('v1/events/'+model.event_id+'/remove-tag');  
      delete model.event_id;
      return this.httpService
        .put(this.token, url, model)
        .pipe(catchError(this.handleError<any>('Remove tags')));
    }
/*
   * @description
   * Remove Disconnect Integration
   * @param model Data to attach with API.
   */
disconnectIntegrationForEvent(model: any) {    
      let url = this.getUrl('v1/events/'+model.event_id+'/remove-integration');  
      delete model.event_id;
      return this.httpService
        .post(this.token, url, model)
        .pipe(catchError(this.handleError<any>('Remove Integration')));
    }
/*
*@description
*Save custom fileds to database
*/

saveCustomFields(model:any){

  let url = this.getUrl('v1/integrations/'+model.event_id+'/save-custom-fields');  
  delete model.event_id;
  return this.httpService
    .post(this.token, url, model)
    .pipe(catchError(this.handleError<any>('Save custom fields')));

}

/*
*@description
*Save webinar custom fileds to database
*/

saveWebinarCustomFields(model:any){

  let url = this.getUrl('v1/integrations/'+model.event_id+'/save-webinar-custom-fields');  
  delete model.event_id;
  return this.httpService
    .post(this.token, url, model)
    .pipe(catchError(this.handleError<any>('Save custom fields')));

}


/*
*@description
*Reload custom fields/tags/list from Autoresponders and save them to database
*/

relaodTagListCustomFields(model:any){

  let url = this.getUrl('v1/integrations/reload-tags-list-customfields');  
  return this.httpService
    .get(this.token, url, model)
    .pipe(catchError(this.handleError<any>('Save custom fields')));

}


/*
*@description
*Save selected list (aweber,mailchimp) to database
*/

saveSelectedList(model:any){

  let url = this.getUrl('v1/integrations/'+model.event_id+'/save-selected-list');  
  delete model.event_id;
  return this.httpService
    .post(this.token, url, model)
    .pipe(catchError(this.handleError<any>('Save selected list')));

}


  /**
   * @description
   * Handle error
   * @param string operation
   * @param T result
   */
   handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return throwError(error);
    };
  }

  /**
   * @description
   * V2 CDN
   * @param url Resource name
   */
   getV2CDN() {
    return this.environment.V2CDN;
  }

}
